import React, { useState } from 'react'
import NewWindow from 'react-new-window'
import { clientTestTypes } from '@/api/Clients/Types/TestQuestionDto'
import { Button } from '@/components/ui/button'
import { Section, TestAnswerDto } from 'api/Clients/Types/TestDto'
import { NameDto } from 'api/Common/Types'
import { PermissionDto } from 'api/Identity/Types/PermissionDto'
import { PermissionsEnum } from 'api/Identity/Types/PermissionsEnum'
import { Box } from 'components/Box'
import {
  DocumentSection,
  QuestionAnswerSection,
  TotalScore,
} from 'components/QuestionAnswerSection'
import { hasPermission } from 'utils/permissionsValidator'

import { DocumentPreviewModal as DocumentPreviewModalComponent } from '../ClientDetailsDocument/DocumentPreviewModal'

interface ClientTestFilledProps {
  existingTest: TestAnswerDto
  allowEdit?: boolean
  permissions: PermissionDto[]
  showScore: boolean
  setFromExistingTest(test: TestAnswerDto): void
  allowRetake(testId: string): void
  type?: clientTestTypes
  scoreNote: string
}

const ClientTestFilled: React.FC<ClientTestFilledProps> = (props) => {
  const {
    existingTest,
    setFromExistingTest,
    allowEdit,
    type,
    permissions,
    allowRetake,
    showScore,
    scoreNote,
  } = props

  const [modal, setModal] = useState<NameDto<string> | null>(null)

  const handleModalClose = () => {
    setModal(null)
  }

  return (
    <React.Fragment>
      {!!modal && <DocumentPreviewModal data={modal} onClose={handleModalClose} />}
      <Box display='flex' flexDirection='column' style={{ margin: '1rem' }}>
        {allowEdit && (
          <Button
            type='button'
            onClick={() => setFromExistingTest(existingTest)}
            style={{
              justifyContent: 'center',
              color: '#1b2337',
              cursor: 'pointer',
              opacity: 0.76,
              marginBottom: '2rem',
            }}
          >
            {'Edit'}
          </Button>
        )}
        {hasPermission(permissions, PermissionsEnum.CanChangeClientTestStatus) &&
          !existingTest.allowRetake &&
          type !== clientTestTypes.economicProfile && (
            <Button
              type='button'
              onClick={() => allowRetake(existingTest.id)}
              style={{
                justifyContent: 'center',
                color: '#1b2337',
                cursor: 'pointer',
                opacity: 0.76,
                marginBottom: '2rem',
              }}
            >
              {'Allow Retake'}
            </Button>
          )}
        {existingTest.sections.map(
          (x, i) =>
            x.answers && (
              <QuestionAnswerSection
                label={x.name}
                items={x.answers}
                showScore={showScore}
                sectionScore={x.totalScore}
                key={x.id + i}
              />
            )
        )}
        {showScore && (
          <TotalScore
            totalScore={existingTest.totalScore ?? calculateTotalScore(existingTest.sections)}
            scoreNote={scoreNote}
          />
        )}
        {existingTest.documents.length > 0 && (
          <DocumentSection
            docs={existingTest.documents}
            onClick={(id, name) => setModal({ id, name })}
          />
        )}
      </Box>
    </React.Fragment>
  )
}

interface DocumentPreviewModalProps {
  data: NameDto<string>
  onClose(): void
}

const DocumentPreviewModal: React.FC<DocumentPreviewModalProps> = (props) => {
  const { data, onClose } = props
  return (
    <NewWindow
      onUnload={onClose}
      copyStyles
      features={{ left: 200, top: 200, width: 520, height: 1000 }}
    >
      <DocumentPreviewModalComponent
        document={{ id: data.id, name: data.name }}
        onClose={onClose}
      />
    </NewWindow>
  )
}

const calculateTotalScore = (section: Section[]) => {
  let totalScore = 0
  section.forEach((sec) => {
    return (totalScore += sec.totalScore)
  })
  return totalScore
}

export default ClientTestFilled
